'use client';

import { deleteToken } from 'firebase/messaging';

import { getMessagingIfSupported } from '@/libs/firebase';

const SUB_KEY = 'fcm_subscribed_token';

export async function cleanupFcmOnLogout(args?: {
    unSubscribeTopic?: (token: string) => Promise<void>;
}) {
    if (typeof window === 'undefined') return;

    const token = localStorage.getItem(SUB_KEY);

    if (token && args?.unSubscribeTopic) {
        await args.unSubscribeTopic(token).catch(() => {});
    }

    const messaging = await getMessagingIfSupported();

    if (messaging) {
        await deleteToken(messaging).catch(() => {});
    }

    localStorage.removeItem(SUB_KEY);
}
